import '@forest/shared/polyfills'

import '@forest/native-diagnostics'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initializeNativeBridge, native } from '@forest/native-services'
import { defineCustomClientStrategy } from '~/paraglide/runtime.js'
import '~/styles/global.css'
import { App } from './app'
import { language } from './params'

defineCustomClientStrategy('custom-queryParam', {
  getLocale: () => language,
  setLocale: () => {},
})

initializeNativeBridge({
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

native.general.pageReady()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
